module.exports = __webpack_public_path__ + "img/JEY.9fdb8fc8.svg";